"use client";

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./Chatbot.css";

const WhatsappChatbot = () => {
  const phoneNumber = "919876543210";

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp_chatbot"
    >
      <FontAwesomeIcon icon={faWhatsapp} className="whatsapp_icon" />
    </a>
  );
};

export default WhatsappChatbot;
